import React from 'react';

import { SVGComponentProps } from './svg.types';

const NoteSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={48}
        height={39}
        viewBox="0 0 48 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_3_7491)">
          <path
            d="M8 6L11.7071 2.29289C11.8946 2.10536 12.149 2 12.4142 2H43C43.5523 2 44 2.44772 44 3V41C44 41.5523 43.5523 42 43 42H5C4.44771 42 4 41.5523 4 41V10.4142C4 10.149 4.10536 9.89464 4.29289 9.70711L8 6Z"
            fill={fill}
          />
        </g>
        <path d="M8 6L12 2V9C12 9.55228 11.5523 10 11 10H4L8 6Z" fill="#211650" />
        <defs>
          <filter
            id="filter0_d_3_7491"
            x={0}
            y={0}
            width={48}
            height={48}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={2} />
            <feGaussianBlur stdDeviation={2} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0745098 0 0 0 0 0.0901961 0 0 0 0 0.12549 0 0 0 0.06 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3_7491" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3_7491"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </span>
  );
};

export default NoteSVG;
